var map = {
	"./ion-action-sheet-controller_8.entry.js": [
		89900,
		9900
	],
	"./ion-action-sheet-ios.entry.js": [
		10984,
		3073,
		9482
	],
	"./ion-action-sheet-md.entry.js": [
		14394,
		3073,
		814
	],
	"./ion-alert-ios.entry.js": [
		6552,
		3073,
		2967
	],
	"./ion-alert-md.entry.js": [
		56868,
		3073,
		5882
	],
	"./ion-app_8-ios.entry.js": [
		66408,
		6408
	],
	"./ion-app_8-md.entry.js": [
		74518,
		4518
	],
	"./ion-avatar_3-ios.entry.js": [
		95926,
		2873
	],
	"./ion-avatar_3-md.entry.js": [
		11526,
		1526
	],
	"./ion-back-button-ios.entry.js": [
		74011,
		4011
	],
	"./ion-back-button-md.entry.js": [
		24069,
		4069
	],
	"./ion-backdrop-ios.entry.js": [
		24896,
		4896
	],
	"./ion-backdrop-md.entry.js": [
		6421,
		6421
	],
	"./ion-button_2-ios.entry.js": [
		30604,
		604
	],
	"./ion-button_2-md.entry.js": [
		84520,
		4520
	],
	"./ion-card_5-ios.entry.js": [
		14540,
		4540
	],
	"./ion-card_5-md.entry.js": [
		91518,
		1518
	],
	"./ion-checkbox-ios.entry.js": [
		72885,
		2885
	],
	"./ion-checkbox-md.entry.js": [
		41816,
		1816
	],
	"./ion-chip-ios.entry.js": [
		99843,
		9843
	],
	"./ion-chip-md.entry.js": [
		79678,
		9678
	],
	"./ion-col_3.entry.js": [
		17478,
		7478
	],
	"./ion-datetime_3-ios.entry.js": [
		77791,
		3073,
		7791
	],
	"./ion-datetime_3-md.entry.js": [
		57043,
		3073,
		7043
	],
	"./ion-fab_3-ios.entry.js": [
		60063,
		63
	],
	"./ion-fab_3-md.entry.js": [
		83067,
		3067
	],
	"./ion-img.entry.js": [
		88014,
		8014
	],
	"./ion-infinite-scroll_2-ios.entry.js": [
		44136,
		4136
	],
	"./ion-infinite-scroll_2-md.entry.js": [
		58964,
		8964
	],
	"./ion-input-ios.entry.js": [
		29183,
		9183
	],
	"./ion-input-md.entry.js": [
		93648,
		3648
	],
	"./ion-item-option_3-ios.entry.js": [
		44528,
		4528
	],
	"./ion-item-option_3-md.entry.js": [
		55312,
		5312
	],
	"./ion-item_8-ios.entry.js": [
		88693,
		8693
	],
	"./ion-item_8-md.entry.js": [
		27315,
		7315
	],
	"./ion-loading-ios.entry.js": [
		79092,
		3073,
		1878
	],
	"./ion-loading-md.entry.js": [
		49738,
		3073,
		6719
	],
	"./ion-menu_4-ios.entry.js": [
		62340,
		3073,
		3022,
		2340
	],
	"./ion-menu_4-md.entry.js": [
		56865,
		3073,
		3022,
		6865
	],
	"./ion-modal-ios.entry.js": [
		43496,
		3073,
		4128
	],
	"./ion-modal-md.entry.js": [
		54630,
		3073,
		2479
	],
	"./ion-nav_5.entry.js": [
		9310,
		9310
	],
	"./ion-popover-ios.entry.js": [
		52525,
		3073,
		7056
	],
	"./ion-popover-md.entry.js": [
		54490,
		3073,
		9190
	],
	"./ion-progress-bar-ios.entry.js": [
		62348,
		2348
	],
	"./ion-progress-bar-md.entry.js": [
		78457,
		8457
	],
	"./ion-radio_2-ios.entry.js": [
		24232,
		4232
	],
	"./ion-radio_2-md.entry.js": [
		67429,
		7429
	],
	"./ion-range-ios.entry.js": [
		43639,
		3639
	],
	"./ion-range-md.entry.js": [
		86072,
		6072
	],
	"./ion-refresher_2-ios.entry.js": [
		10497,
		497
	],
	"./ion-refresher_2-md.entry.js": [
		51673,
		1673
	],
	"./ion-reorder_2-ios.entry.js": [
		751,
		751
	],
	"./ion-reorder_2-md.entry.js": [
		64022,
		4022
	],
	"./ion-ripple-effect.entry.js": [
		84905,
		4905
	],
	"./ion-route_4.entry.js": [
		85095,
		5095
	],
	"./ion-searchbar-ios.entry.js": [
		60818,
		818
	],
	"./ion-searchbar-md.entry.js": [
		84524,
		4524
	],
	"./ion-segment_2-ios.entry.js": [
		44513,
		4513
	],
	"./ion-segment_2-md.entry.js": [
		49297,
		9297
	],
	"./ion-select_3-ios.entry.js": [
		9804,
		9804
	],
	"./ion-select_3-md.entry.js": [
		27106,
		7106
	],
	"./ion-slide_2-ios.entry.js": [
		25585,
		5585
	],
	"./ion-slide_2-md.entry.js": [
		59109,
		9109
	],
	"./ion-spinner.entry.js": [
		72429,
		3046
	],
	"./ion-split-pane-ios.entry.js": [
		62131,
		2131
	],
	"./ion-split-pane-md.entry.js": [
		33005,
		3005
	],
	"./ion-tab-bar_2-ios.entry.js": [
		21911,
		1911
	],
	"./ion-tab-bar_2-md.entry.js": [
		86907,
		6907
	],
	"./ion-tab_2.entry.js": [
		13965,
		3965
	],
	"./ion-text.entry.js": [
		42516,
		2516
	],
	"./ion-textarea-ios.entry.js": [
		77800,
		7800
	],
	"./ion-textarea-md.entry.js": [
		82210,
		2210
	],
	"./ion-toast-ios.entry.js": [
		55423,
		3073,
		4647
	],
	"./ion-toast-md.entry.js": [
		26238,
		3073,
		2545
	],
	"./ion-toggle-ios.entry.js": [
		93644,
		3644
	],
	"./ion-toggle-md.entry.js": [
		19543,
		4464
	],
	"./ion-virtual-scroll.entry.js": [
		19480,
		9480
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 98085;
module.exports = webpackAsyncContext;